module.exports = "pegasus/assets/classic-linkedin.png";